/* eslint-disable no-undef */
/* eslint-disable no-underscore-dangle */

import { v4 as uuid } from 'uuid';

const getAlgoliaKey = async () => {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  const raw = JSON.stringify({
    searchKey: '5920763761ceb8241474954becc13e37',
  });
  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow',
  };
  let algoliaKeyRes = '';
  try {
    const mobiusResponse = await fetch(
      `https://api.mobius.highereducation.com/v1/algolia/key?idToken=${HE.publisher.identityToken}`,
      requestOptions
    );
    const responseText = await mobiusResponse?.text();
    const json = JSON.parse(responseText);
    algoliaKeyRes = json?.key || '';

    if (!algoliaKeyRes) {
      throw new Error('Algolia key empty');
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error fetching algolia key', error);
    window.newrelic.noticeError(error);
  }
  return algoliaKeyRes;
};
const debounce = (func, timeout = 300) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
};
const getCookie = (name) => {
  const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
  return v ? v[2] : null;
};
const getTrafficSource = (urlString) => {
  const urlParams = new URLSearchParams(urlString);
  let source = (
    urlParams.has('utmCap') || urlParams.has('utm_cap')
      ? urlParams.get('utmCap') || urlParams.get('utm_cap')
      : 'organic'
  ).toLowerCase();

  if (['search', 'social'].includes(source)) {
    source = `paid ${source}`;
  }
  return source;
};
const getUrlQuery = (base = null, params = {}) => {
  if (!base) throw Error('base is required');

  // stringify & filter params
  const queryParams = Object.entries(params)
    .map(([key, value]) => {
      // return, if empty or null
      if (value === '' || value === null) {
        return false;
      }

      // stringify objects
      const valueString =
        typeof value === 'object' ? JSON.stringify(value) : value;

      // return key=value
      return `${key}=${encodeURIComponent(valueString)}`;
    })
    .filter((param) => param);

  if (queryParams.length <= 0) {
    return base;
  }

  return base + (base.includes('?') ? '&' : '?') + queryParams.join('&');
};

(async () => {
  let algoliaKey = getCookie('algoliaKey');
  if (!algoliaKey) {
    algoliaKey = await getAlgoliaKey();
    document.cookie = `algoliaKey=${algoliaKey}; max-age=3000; path=/`;
  }
  const acpfEl = document.querySelector('.acpf');
  const hitsEl = acpfEl.querySelector('.acpf__hits');
  const searchboxEl = acpfEl.querySelector('.acpf__searchbox');
  const filterButtonsEl = document.querySelectorAll('.acpf__filters-button');
  const takeQuizEl = document.querySelector('.acpf__hits-item--quiz');
  const acpfData = {
    school: 'school.name',
    program: 'program.name',
    algoliIndex: 'production_edudirect_programs',
    degreeFacet: 'program.degree.name',
    programFacet: 'program.subject.name',
    searchBoxPlaceholder: 'Search 2,000+ schools & programs',
    currentPageDegree: window.HE?.contextualDefaults?.degree?.name,
    currentPageProgram: window.HE?.contextualDefaults?.subject?.name,
    token: window.HE?.publisher?.identityToken,
    isFirstFacetSearch: true,
    isFirstTextSearch: true,
  };

  if (!algoliaKey) {
    acpfEl.style.display = 'none';
    return;
  }

  const emptyTemplate = ({ query }, { html }) =>
    html`<div class="ais-Hits-item">
      <div class="acpf__hits-item" data-query="${query}">
        Adjust Your Search for Better Matches.
      </div>
    </div>`;
  const itemTemplate = (hit, { html, components }) => {
    const correlationId = uuid();
    const helid = uuid();
    const position = hit?.__position;
    const source = getTrafficSource(document.location?.href);
    const trackingContext = {
      webContext: window._Cohesion?.webContext,
      tenantId: window._Cohesion?.tenantId,
      writeKey: window._Cohesion?.writeKey,
      formatType: 'ad',
      formatSubtype: 'program-search',
    };
    const querystringParams = {
      correlationId,
      idToken: acpfData.token,
      helid,
      position,
      source,
      trackingContext,
    };
    const url = getUrlQuery(hit.url, querystringParams);

    return html`
      <a
        class="acpf__hits-item"
        href="${url}"
        target="_blank"
        data-program-id="${hit?.program?.id}"
        data-position="${position}"
        data-correlation="${correlationId}"
      >
        <div>
          <p class="acpf__hits-item-title">
            ${components.Highlight({ attribute: acpfData.school, hit })}
          </p>
          <p class="acpf__hits-item-desc">
            ${components.Highlight({ attribute: acpfData.program, hit })}
          </p>
        </div>
        <div class="acpf__hits-item-extenal-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 14 14"
            fill="#A1A1AA"
          >
            <path
              fill="inherit"
              d="M8 0a1 1 0 0 0 0 2h2.586L4.293 8.293a1 1 0 0 0 1.414 1.414L12 3.414V6a1 1 0 1 0 2 0V1a1 1 0 0 0-1-1H8Z"
            />
            <path
              fill="inherit"
              d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a1 1 0 1 0-2 0v3H2V4h3a1 1 0 0 0 0-2H2Z"
            />
          </svg>
        </div>
      </a>
    `;
  };
  const facetsList = [];
  const searchClient = algoliasearch('YG3L958NUT', algoliaKey);
  const search = instantsearch({
    indexName: acpfData.algoliIndex,
    searchClient,
    searchFunction(helper) {
      if (helper.state.query === '') {
        acpfEl.classList.remove('acpf--open');
      } else {
        acpfEl.classList.add('acpf--open');
      }
      helper.search();
    },
  });
  const configure = instantsearch.widgets.configure({
    filters: '',
    hitsPerPage: 4,
    enablePersonalization: true,
    restrictSearchableAttributes: [acpfData.school, acpfData.program],
  });
  const searchBox = instantsearch.widgets.searchBox({
    container: searchboxEl,
    placeholder: acpfData.searchBoxPlaceholder,
    queryHook: debounce((query, hookSearch) => {
      hookSearch(query);
    }, 350),
  });
  const hits = instantsearch.widgets.hits({
    container: hitsEl,
    templates: {
      item: itemTemplate,
      empty: emptyTemplate,
    },
  });
  const filterByFacet = (filtersList = []) => {
    let filter = '';
    filtersList?.forEach(({ facet, value }) => {
      filter += filter ? ` AND ${facet}:"${value}"` : `${facet}:"${value}"`;
    });
    search.helper.setQueryParameter('filters', filter);
    search.helper.search();
  };
  const clearFilterStyle = () => {
    filterButtonsEl.forEach((filterButton) => {
      filterButton.classList.remove('acpf__filters-button--active');
    });
  };
  const showHits = () => {
    // remove inline style to prevent LCP
    hitsEl.style = '';
    acpfEl.classList?.add('acpf--open');

    // TODO:find a better way to handle the event log when algolia response finished
    setTimeout(() => {
      acpfEl
        .querySelectorAll('.ais-Hits-list a.acpf__hits-item')
        .forEach((el) => {
          const anchorEl = el;
          const viewCorrelationId = uuid();
          const universityName = anchorEl?.querySelector(
            '.acpf__hits-item-title'
          )?.innerText;
          const programName = anchorEl?.querySelector(
            '.acpf__hits-item-desc'
          )?.innerText;
          const position = anchorEl?.dataset?.__position;
          const { programId } = anchorEl?.dataset;

          anchorEl.dataset.viewCorrelationId = viewCorrelationId;
          window.tagular('beam', 'ProductViewed', {
            '@type': 'redventures.ecommerce.v1.ProductViewed',
            viewCorrelationId,
            product: {
              brand: universityName,
              formatSubtype: 'program-search',
              formatType: 'ad',
              location: 'sticky-atf',
              name: programName,
              position,
              productId: programId,
            },
          });
        });
    }, 750);
  };
  const closeHits = () => {
    acpfEl.classList?.remove('acpf--open');
    // Force search in order to get new correlationId
    search.helper.search();
  };
  const isAcpfOpen = () => acpfEl.classList.contains('acpf--open');

  // reset filters when no results
  search.on('render', () => {
    if (search.status === 'idle' && acpfData.isFirstFacetSearch) {
      acpfData.isFirstFacetSearch = false;
      if (search?.helper?.lastResults?.hits?.length) return;

      filterByFacet();
    }
  });

  search.on('error', () => {
    window.newrelic.noticeError(search?.error);
  });

  // Algolia Init
  search.addWidgets([configure, searchBox, hits]);
  search.start();

  if (acpfData?.currentPageDegree) {
    facetsList.push({
      facet: acpfData.degreeFacet,
      value: acpfData.currentPageDegree,
    });
  }

  if (acpfData?.currentPageProgram) {
    facetsList.push({
      facet: acpfData.programFacet,
      value: acpfData.currentPageProgram,
    });
  }

  if (facetsList.length) {
    filterByFacet(facetsList);
  }

  // event listeners
  filterButtonsEl.forEach((filterButton) => {
    filterButton.addEventListener('click', (event) => {
      const facetValue = event.target.dataset.value;
      const text = event.currentTarget.innerText;
      const param = facetValue
        ? [{ facet: acpfData.degreeFacet, value: facetValue }]
        : null;

      filterByFacet(param);
      clearFilterStyle();
      event.currentTarget?.classList?.add('acpf__filters-button--active');
      showHits();
      document.querySelector('.acpf__searchbox input').focus();

      window.tagular('beam', 'ElementClicked', {
        '@type': 'redventures.usertracking.v3.ElementClicked',
        webElement: {
          name: 'search-engagement',
          location: 'sticky-atf',
          elementType: 'acpf-pill',
          text,
        },
        actionOutcome: 'INTERNALLINK',
      });
    });
  });

  searchboxEl.querySelector('input').addEventListener('click', () => {
    const viewCorrelationId = uuid();
    showHits();

    window.tagular('beam', 'ElementClicked', {
      '@type': 'redventures.usertracking.v3.ElementClicked',
      webElement: {
        name: 'search-engagement',
        location: 'sticky-atf',
        elementType: 'search-bar',
      },
      viewCorrelationId,
      actionOutcome: 'INTERNALLINK',
    });
  });

  searchboxEl.querySelector('input').addEventListener('keydown', () => {
    if (acpfData.isFirstTextSearch) {
      acpfData.isFirstTextSearch = false;
      filterByFacet();
    }
  });

  searchboxEl.querySelector('input').addEventListener('change', (event) => {
    const correlationId = uuid();
    window.tagular('beam', 'FieldInputted', {
      '@type': 'redventures.usertracking.v3.FieldInputted',
      userInputField: {
        autofilled: false,
        fieldName: 'search-engagement',
        fieldType: 'text',
        fieldLabel: 'algolia-search',
        fieldValue: event?.target?.value,
      },
      correlationId,
    });
  });

  // close acpf
  document.addEventListener('click', (event) => {
    if (
      !acpfEl.contains(event.target) ||
      (isAcpfOpen() && event.target?.classList?.contains('acpf__filters'))
    ) {
      closeHits();
    }
  });

  takeQuizEl.addEventListener('click', (event) => {
    const text = event.currentTarget.innerText;
    const viewCorrelationId = uuid();

    window.tagular('beam', 'ElementClicked', {
      '@type': 'redventures.usertracking.v3.ElementClicked',
      webElement: {
        name: 'quiz-entry',
        location: 'sticky-atf',
        elementType: 'quiz-acpf',
        text,
      },
      viewCorrelationId,
      actionOutcome: 'INTERNALLINK',
    });
  });

  hitsEl.addEventListener('click', (event) => {
    const anchorEl = event.target?.closest('a.acpf__hits-item');
    if (anchorEl.classList.contains('acpf__hits-item--quiz')) return;

    const correlationId = anchorEl?.dataset?.correlation;
    const viewCorrelationId = anchorEl?.dataset?.viewCorrelationId;
    const universityName = anchorEl?.querySelector(
      '.acpf__hits-item-title'
    )?.innerText;
    const programName = anchorEl?.querySelector(
      '.acpf__hits-item-desc'
    )?.innerText;
    const position = parseInt(anchorEl?.dataset?.position, 16);
    const { programId } = anchorEl?.dataset;

    closeHits();

    window.tagular('beam', 'ProductClicked', {
      '@type': 'redventures.ecommerce.v1.ProductClicked',
      correlationId,
      viewCorrelationId,
      outboundUrl: anchorEl.href,
      product: {
        brand: universityName,
        formatSubtype: 'program-search',
        formatType: 'ad',
        location: 'sticky-atf',
        name: programName,
        position,
        positionEngine: 'algolia',
        productId: programId,
      },
    });
  });

  window.onscroll = () => {
    if (!isAcpfOpen()) return;
    closeHits();
  };
})();
